import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Button from '../../../../Shared/Form/Button'
import Modal from '../../../../Shared/Modal'
import Loader from '../../../../Shared/Loader'
import Alert from '../../../../Shared/Alert'
import { createPaymentLinkForInvoice } from '../../../../../api'
import PropTypes from 'prop-types'

const initialState = {
  showModal: false,
  loading: false,
  error: false,
  paymentLink: ''
}

class PaymentLinkCreator extends Component {

  constructor (props) {
    super(props)

    this.state = Object.assign({}, initialState)
  }

  componentDidMount () {
    this.mounted = true
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.invoiceId !== prevProps.invoiceId) {
      this.setState(Object.assign({}, initialState))
    }
  }

  componentWillUnmount () {
    this.mounted = false
  }

  close = (e) => {
    if (e) {
      e.stopPropagation()
    }
    if (this.state.paymentLink !== '') {
      this.props.onPaymentLinkCreated(this.props.invoiceId, this.state.paymentLink)
    }
    this.setState({ showModal: false })
  }

  open = () => {
    this.setState({ showModal: true })
  }

  showPaymentLinkModal = (e) => {
    e.stopPropagation()
    this.setState(Object.assign({}, initialState, { showModal: true }))
  }

  createPaymentLink = (e) => {
    e.stopPropagation()
    this.setState({ loading: true, error: false }, () => {
      const {
        fetchPromise,
      } = createPaymentLinkForInvoice(this.props.invoiceId)
      fetchPromise.then((response) => {
        if (!this.mounted) return
        this.setState({ paymentLink: response.paymentLink })
      }).catch(() => {
        if (!this.mounted) return
        this.setState({ error: true })
      }).finally(() => {
        if (!this.mounted) return
        this.setState({ loading: false })
      })
    })
  }

  render () {
    const { t } = this.props

    return (
      <React.Fragment>
      <span onClick={this.showPaymentLinkModal}>
        <br/><Button classNames={'Button-Small'}>{t('CREATE_NEW_PAYMENTLINK')}</Button>
      </span>
        <Modal show={this.state.showModal || this.state.loading}>
          {this.state.loading ?
            <Loader size={32}/>
            :
            <div>
              {this.state.error && <Alert type={'danger'}>Failed to create payment link</Alert>}
              {!this.state.error &&
                <React.Fragment>
                  <h4>{t('PAYMENT_LINK')}</h4>
                  <div><Alert type={'info'}>{t('PAYMENT_LINK_CREATION_INFO')}</Alert></div>
                  {this.state.paymentLink &&
                    <div>{t('PAYMENT_LINK')}: <a href={this.state.paymentLink} target={'_blank'} rel="noreferrer">{this.state.paymentLink}</a></div>}
                </React.Fragment>
              }
              <div style={{ justifyContent: 'center', marginTop: '20px', gap: '30px', display: 'flex' }}>
                <Button onClick={this.close}>{t('CLOSE')}</Button>
                {!this.state.paymentLink &&
                  <Button classNames={'Button-CTA'}
                          onClick={this.createPaymentLink}>{t('CREATE_NEW_PAYMENTLINK')}</Button>}
              </div>
            </div>
          }
        </Modal>
      </React.Fragment>
    )
  }
}

PaymentLinkCreator.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  onPaymentLinkCreated: PropTypes.func.isRequired
}
export default withTranslation()(PaymentLinkCreator)
